class Identification {
  init () {
    $('.form-wrapper').find('#user_login').attr('placeholder', 'Renseignez votre email')
    $('.form-wrapper').find('#user_pass').attr('placeholder', 'Renseignez votre mot de passe')
    $('.form-wrapper').find('#pass1').attr('placeholder', 'Mot de passe')
    $('.form-wrapper').find('#pass2').attr('placeholder', 'Confirmation du Mot de passe')
    $('.form-wrapper').find('.tml-lostpassword-link a').text('Mot de passe oublié / première connexion')

    // show/hide password
    const passwordField = $('.form-wrapper').find('#user_pass')
    const passwordConfirmationField = $('.form-wrapper').find('#pass2')
    const passwordField1 = $('.form-wrapper').find('#pass1')

    addTogglePasswordButton(passwordField)
    addTogglePasswordButton(passwordConfirmationField)
    addTogglePasswordButton(passwordField1)

    function addTogglePasswordButton (field) {
      const toggleButton = $('<span class="toggle-password" style="cursor: pointer; position: absolute; top: 56%; right:12px"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8727 7.58882C15.7309 7.38184 12.3498 2.52002 8.00015 2.52002C3.6497 2.52002 0.269091 7.38189 0.127273 7.58887C-0.0424243 7.83658 -0.0424243 8.16318 0.127273 8.41093C0.269091 8.61787 3.6497 13.4798 8.00015 13.4798C12.3498 13.4798 15.7309 8.61791 15.8727 8.41098C16.0424 8.16322 16.0424 7.83658 15.8727 7.58882ZM8.00015 12.0253C5.07724 12.0253 2.50007 9.09855 1.6354 7.99925C2.49862 6.89888 5.069 3.97457 8.00015 3.97457C10.9219 3.97457 13.4987 6.90005 14.3641 7.99988C13.4983 9.10019 10.9217 12.0253 8.00015 12.0253Z" fill="#8E9798"/><path d="M8.00015 5.98029C6.88427 5.98029 5.97979 6.88342 5.97979 7.99988C5.97979 9.11639 6.88427 10.0195 8.00015 10.0195C9.1153 10.0195 10.0205 9.11639 10.0205 7.99988C10.0205 6.88342 9.1153 5.98029 8.00015 5.98029Z" fill="#8E9798"/></svg></span>')

      field.after(toggleButton)

      toggleButton.click(function () {
        const passwordInput = field.get(0)
        if (passwordInput.type === 'password') {
          passwordInput.type = 'text'
        } else {
          passwordInput.type = 'password'
        }
      })
    }

    // remove confidentiality content
    const privacyCheckbox = $('.tml-privacy-checkbox')
    const submitWrap = $('.tml-field-wrap.tml-submit-wrap')

    privacyCheckbox.insertBefore(submitWrap)

    // password
    const passAlertResult = $('.tml-resetpass .tml-alerts')
    const btnResetPassword = $('.tml-resetpass .tml-button')
    btnResetPassword.attr('disabled', 'disabled')
    passAlertResult.css('display', 'none')

    $('#pass1, #pass2').on('keyup', function () {
      validatePassword()
    })
    function validatePassword () {
      passAlertResult.css('display', 'block')
      const pass1 = $('#pass1').val()
      const pass2 = $('#pass2').val()

      // Vérifier la longueur minimale
      const minLength = 8
      const hasMinLength = pass1.length >= minLength

      // Vérifier au moins une majuscule, un chiffre et un caractère spécial
      const hasUppercase = /[A-Z]/.test(pass1)
      const hasDigit = /\d/.test(pass1)
      const hasSpecialChar = /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/.test(pass1)

      // Vérifier si les deux mots de passe correspondent
      const passwordsMatch = pass1 === pass2

      // Afficher les erreurs
      let errorMessage = '<div class="tml-alerts"><ul class="tml-errors"><li class="tml-error">'
      if (!hasMinLength) {
        errorMessage += '- Le mot de passe doit comporter au moins ' + minLength + ' caractères.<br>'
      }
      if (!hasUppercase) {
        errorMessage += '- Le mot de passe doit contenir au moins une majuscule.<br>'
      }
      if (!hasDigit) {
        errorMessage += '- Le mot de passe doit contenir au moins un chiffre.<br>'
      }
      if (!hasSpecialChar) {
        errorMessage += '- Le mot de passe doit contenir au moins un caractère spécial.<br>'
      }
      if (!passwordsMatch) {
        errorMessage += '- Les mots de passe ne correspondent pas.'
      }
      errorMessage += '</li></ul></div>'

      // Afficher le message d'erreur
      passAlertResult.html(errorMessage)

      if (passAlertResult.find('.tml-error:empty').length > 0) {
        passAlertResult.hide()
      } else {
        passAlertResult.show()
      }

      if (!hasMinLength || !hasUppercase || !hasDigit || !hasSpecialChar || !passwordsMatch) {
        btnResetPassword.attr('disabled', 'disabled')
      } else {
        btnResetPassword.removeAttr('disabled')
      }
    }
  }
}

export default Identification
